import useModal from '../../../useModal';
import UseContext from '../../../../../hooks/useContext';
import Modalheader from '../../../components/header';
import ModalBody from '../../../components/body';
import ModalFooter from '../../../components/footer';
import Button from '../../../../button';
import ApiDatabase from '../../../../../server';
import { useState } from 'react';
import { toast } from 'react-toastify';

const ModalPayslipImportUnit = () => {
  const { toggle } = useModal();
  const { modalData, setModalDataReturn } = UseContext();
  const token = localStorage.getItem('xsrfToken');

  const payslip = modalData?.payslips?.[0] || {};
  const year = modalData?.year || '';
  const month = modalData?.month || '';

  const [sendNotifications, setSendNotifications] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const handleConfirm = () => {
    setIsLoading(true);
    ApiDatabase.importPayslips(
      {
        token,
        year,
        month,
        paid: true,
        id_temp_worker_bestt: [payslip.id_temp_worker_bestt],
        sendNotifications,
      },
      () => {
        setIsLoading(false);
        toast.success('Import lancé.');
        setModalDataReturn({
          action: 'payslips_imported',
          id_temp_worker_bestt: [payslip.id_temp_worker_bestt],
          year,
          month,
        });
        toggle();
      },
      (err) => {
        setIsLoading(false);
        toast.error(err.response?.data?.error || 'Erreur');
      }
    );
  };

  return (
    <>
      <Modalheader hide={toggle} hideShow={true}>
        Importer une fiche de paie
      </Modalheader>
      <ModalBody>
        <div className="flex flex-col gap-3 text-sm">
          <div>
            <strong>ID :</strong> {payslip.id_temp_worker_bestt}
          </div>
          <div>
            <strong>Nom :</strong> {payslip.lastname} {payslip.firstname}
          </div>
          <div>
            <strong>Période :</strong> {year}/{month}
          </div>
          <div>
            <strong>Montant :</strong>{' '}
            {payslip.amount ? `${Number(payslip.amount).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} €` : '-'}
          </div>
          <label className="flex items-center gap-2 cursor-pointer mt-2">
            <input
              type="checkbox" className="checkbox-primary"
              checked={sendNotifications}
              onChange={() => setSendNotifications(!sendNotifications)}
            />
            Notifier l'utilisateur
          </label>
        </div>
      </ModalBody>
      <ModalFooter>
        <div className="flex gap-2">
          <Button onClick={toggle} size="LG" color="SECONDARY">
            Annuler
          </Button>
          <Button onClick={handleConfirm} size="LG" disabled={isLoading}>
            {isLoading ? 'Import en cours...' : 'Confirmer'}
          </Button>
        </div>
      </ModalFooter>
    </>
  );
};

export default ModalPayslipImportUnit;
